






































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
const Debtors = namespace("DebtorsModule");
import Paginate from "@/components/Paginate.vue";
import { BOverlay } from "bootstrap-vue";
import moment from "moment";
import DatePicker from "vue2-datepicker";

@Component({
  name: "DebtorTracking",
  components: {
    DatePicker,
    Paginate,
    BOverlay,
  },
})
export default class Debtor extends Vue {
  private filter = {
    Date: "",
    Number: 0,
    sort: "desc",
    index: "DebtorId"
  };

  private debtors = [];
  private debtorNumber = ""
  private debtorDate = "";
  private loading = true;
  private dataPagination = {
    perPage: 0,
    totalRow: 0,
    currentPage: 0,
    limit: 0,
  };

  pageChange(params: any) {
    this.getTrackingPerPage({
      page: params.currentPage,
      filter: this.filterQuery(),
    }).then(
      (response) => {
        this.debtors = response.debtorTrackingList;
        if (response.Paginate) {
          this.dataPagination = response.Paginate;
        }
      }
    );
  }

  private filterQuery() {
    const filter = this.filter;
    const filterData: any = {
      Index: this.filter.index
    };

    if (this.debtorDate !== undefined) {
      this.filter.Date = this.debtorDate;
    }
    if (this.debtorNumber) {
      filterData.DebtorId = parseInt(this.debtorNumber);
    }

    //index using and sort
    if (filter?.index && !this.debtorDate) {
      filterData.Index = "Date";
    }
    if (filter.sort) {
      filterData.Sort = filter.sort;
    }

    filterData.Filter = this.makeFilter();
    return filterData;
  }

  private makeFilter() {
    const filter = this.filter;
    const Filter = [];
    if (filter.Date) {
        Filter.push(
            {
                Key: "Date",
                Operator: "greatThanEqual",
                Value: this.debtorDate,
            },
            {
                Key: "Date",
                Operator: "lessThanEqual",
                Value: moment(this.debtorDate).add(1, 'day'),
            }
        );
    }

    return Filter;
  }
  // ---- End Handling Paginate ----

  onSearch() {
    this.loading = true;
    this.retrieveDebtorsTracking(this.filterQuery()).then(
      (response) => {
        this.dataPagination = response.Paginate;
        this.debtors = response.debtorTrackingList;
        this.loading = false;
      }
    );
  }

  created() {
    this.onSearch();
  }

  @Debtors.Action
  public retrieveDebtorsTracking!: (params: any) => Promise<any>;

  @Debtors.Action
  public getTrackingPerPage!: (params: any) => Promise<any>;

}
